import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { MetaVerifiedBadge } from "../components/MetaVerifiedBadge";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-bone grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-5 sm:p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <Link to="/" className="font-heading font-black text-2xl tracking-tighter inline-block mb-10 sm:mb-12">InstaVibe<span className="text-klein">.</span></Link>
          <div className="overline mb-3 sm:mb-4">— Sign in</div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl tracking-tighter mb-6 sm:mb-8 leading-tight">Welcome back.</h1>
          <div className="space-y-5">
            <div>
              <label className="label-overline">Email</label>
              <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="input-field" data-testid="login-email" />
            </div>
            <div>
              <label className="label-overline">Password</label>
              <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="input-field" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full mt-2" data-testid="login-submit">
              {loading ? "Signing in…" : (<>Sign in <ArrowUpRight className="w-4 h-4" /></>)}
            </button>
          </div>
          <div className="mt-8 text-sm text-white/60">No account yet? <Link to="/signup" className="font-semibold text-klein hover:text-klein-dark" data-testid="login-goto-signup">Create one</Link></div>
          <div className="mt-8 pt-6 border-t border-white/5">
            <MetaVerifiedBadge variant="compact" />
          </div>
        </form>
      </div>
      <div className="hidden lg:flex items-center justify-center bg-obsidian p-12 relative overflow-hidden">
        <div className="relative z-10">
          <div className="overline text-white/60 mb-4">— 10,000+ creators use InstaVibe</div>
          <blockquote className="font-heading font-black text-5xl text-white tracking-tighter leading-[0.95] max-w-md">
            "I sell my ebook from a single IG comment now. It feels like printing money."
          </blockquote>
          <div className="mt-8 text-white/70 font-mono text-sm">— Mira L., food creator</div>
        </div>
      </div>
    </div>
  );
}
